<div class="screen-container flex-1 d-flex fd-col jc-start ai-stretch">
  <app-customer-header></app-customer-header>
  <div class="slim-padding">
    <div class="alert alert-warning" *ngIf="!alias">
      <div class="identity-margin">Email alerts debug</div>
      <div>
        The route data has not produced an alias yet, so the email alerts form cannot render.
      </div>
      <pre>{{ debugState | json }}</pre>
    </div>
    <lib-manage-email-alerts *ngIf="alias" [alias]="alias"></lib-manage-email-alerts>
  </div>
</div>
